import { render, staticRenderFns } from "./verWebQ.vue?vue&type=template&id=73a2964a"
import script from "./verWebQ.vue?vue&type=script&lang=js"
export * from "./verWebQ.vue?vue&type=script&lang=js"
import style0 from "./verWebQ.vue?vue&type=style&index=0&id=73a2964a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports